export const shippingReciveAccioneRoles = {
  sharedActions: {
    registerPurchaseOrder: [
      'Chief',
      'Admin',
      'Viewer',
      'ShippingReceiveAdmin',
      'ShippingReceiveChief',
      'ShippingReceiveViewer',
      'ShippingReceiveSupervisor',
      'ShippingReceiveLeader',
      'QualityControl',
      'QualityControlLaboratory',
      'QualityControlInspector',
    ],
    inspectionSheets: [
      'Chief',
      'Admin',
      'Viewer',
      'ShippingReceiveAdmin',
      'ShippingReceiveChief',
      'ShippingReceiveViewer',
      'ShippingReceiveSupervisor',
      'QualityControl',
    ],
    scrapRefund: [
      'Chief',
      'Admin',
      'Viewer',
      'ShippingReceiveAdmin',
      'ShippingReceiveChief',
      'ShippingReceiveViewer',
      'ShippingReceiveSupervisor',
      'QualityControl',
      'QualityControlInspector',
    ],
    boxTracing: [
      'Viewer',
      'ShippingReceiveTruckUser',
      'ShippingReceiveTruckAdmin',
      'ShippingReceiveViewer',
    ],
    boxStatus: ['ShippingReceiveTruckUser', 'ShippingReceiveTruckAdmin'],
    boxEdit: ['ShippingReceiveTruckAdmin'],
  },

  sideNavActions: {
    shippingReceive: [
      'Chief',
      'Admin',
      'Viewer',
      'ShippingReceiveAdmin',
      'ShippingReceiveChief',
      'ShippingReceiveViewer',
      'QualityControl',
      'ShippingReceiveSupervisor',
      'ShippingReceiveLeader',
      'QualityControlLaboratory',
      'QualityControlInspector',
      'ShippingReceiveTruckUser',
      'ShippingReceiveTruckAdmin',
      'ShippingReceiveViewer',
    ],
  },
};
